import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from './icon-control'
import linkify from '../lib/linkify'

const ExpandoLink = linkify(styled.span``)

const ContainerDiv = styled.div`
  margin-bottom: 32px;  
`

const ContainerFooterDiv = styled.div`
  margin-bottom: 32px;
  margin-left: 22px;
  margin-right: 44px;  
`

const PaddedContent = styled.div`
  margin-left: 26px;
`

const PaddedFooterContent = styled.div`
  margin-left: 26px;
  margin-bottom: 20px;
`

interface IProps {
  title: string
  marginLeft?: boolean
}

interface IState {
  expanded: boolean
}

class ExpandoControl extends React.Component<IProps, IState> {
  state: IState = {
    expanded: false
  }

  handleToggle = () => this.setState(prev => ({ expanded: !prev.expanded }))

  render() {
    const rotation = this.state.expanded ? -90 : 0
    const iconStyle = {
      transform: `rotate(${rotation}deg)`,
      transition: 'transform 0.3s',
      marginRight: 8
    }
    const title = this.state.expanded ? 'Hide content' : this.props.title
    return (
      this.props.marginLeft ?
        <ContainerFooterDiv>
          {this.state.expanded && (
            <PaddedFooterContent>{this.props.children}</PaddedFooterContent>
          )}
          <div>
            <ExpandoLink onClick={this.handleToggle}>
              <IconControl icon="chevron-right" style={iconStyle} />
              {title}
            </ExpandoLink>
          </div>
        </ContainerFooterDiv> :
        <ContainerDiv>
          {this.state.expanded && (
            <PaddedContent>{this.props.children}</PaddedContent>
          )}
          <div>
            <ExpandoLink onClick={this.handleToggle}>
              <IconControl icon="chevron-right" style={iconStyle} />
              {title}
            </ExpandoLink>
          </div>
        </ContainerDiv>
    )
  }
}

export default ExpandoControl
